import Form from './Form';
import Filter from './Filter';
import api from '@/plugins/api';

import component from './component.vue';

export default class TourClientList {
  component = component;

  form = new Form(this);

  filter = new Filter(this);

  items = [];

  __items = [];

  loading = false;

  constructor() {
    this.filter.$subscribe(() => {
      this.setFilters();
    });
  }


  set(data = []) {
    let min = Infinity;
    let max = 0;

    this.__items = data.map((i) => {
      if (min > i.minCost) {
        min = i.minCost;
      }
      if (max < i.minCost) {
        max = i.minCost;
      }
      return {
        ...i,
        name: i.tourName || '',
        id: i.id || null,
        cost: i.minCost,
        date: i.minCostDate?.serialized || '',
        type: i.tourType,
        legal: i.ownerLegal,
        description: i.shortDescription,
        preview: i.previewImageUrl,
        dates: i.daysQuota.map(j => ({
          value: j.tour.value,
          label: j.date.serialized,
          quota: j.activeQuota,
          date: j.date.value,
          price: j.price,
        })),
      };
    });
    this.__items.sort((a, b) => a.cost - b.cost);
    this.filter.priceFrom.set(min);
    this.filter.priceTo.set(max);
    this.setFilters();
  }

  setFilters() {
    const filters = this.filter.value;
    const name = filters.name?.toLowerCase() || '';
    const min = filters.priceFrom || 0;
    const max = filters.priceTo || Infinity;
    this.items = this.__items.filter((i) => {
      if (name && i.name.toLowerCase()
        .indexOf(name) === -1) {
        return false;
      }
      if (min && min > i.cost) {
        return false;
      }
      if (max && max < i.cost) {
        return false;
      }
      return true;
    });
  }

  submit() {
    this.loading = true;
    return api.tour.client
      .list(this.form.data)
      .then((data = {}) => this.set(data.tours))
      .finally(() => {
        this.loading = false;
      });
  }

  init() {
    this.loading = true;
    return Promise
      .all([
        this.form.init(),
        this.filter.init(),
      ])
      .finally(() => {
        this.loading = false;
      });
  }
}
